import { render, staticRenderFns } from "./modelLink.vue?vue&type=template&id=15fc677f&"
import script from "./modelLink.vue?vue&type=script&lang=js&"
export * from "./modelLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports